import { render, staticRenderFns } from "./AccountList.vue?vue&type=template&id=5c3a05ca&scoped=true&"
import script from "./AccountList.vue?vue&type=script&lang=js&"
export * from "./AccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a05ca",
  null
  
)

export default component.exports